var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContact04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_885_31248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M129.76 114.15C132.72 114.15 135.12 111.75 135.12 108.79C135.12 105.829 132.72 103.43 129.76 103.43C126.8 103.43 124.4 105.829 124.4 108.79C124.4 111.75 126.8 114.15 129.76 114.15Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.85 30.0091C29.8102 30.0091 32.21 27.6093 32.21 24.6491C32.21 21.6888 29.8102 19.2891 26.85 19.2891C23.8897 19.2891 21.49 21.6888 21.49 24.6491C21.49 27.6093 23.8897 30.0091 26.85 30.0091Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.56 108.07C68.3 108.07 68.3 103.82 65.56 103.82C62.82 103.82 62.82 108.07 65.56 108.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.15 134.32C27.89 134.32 27.89 130.07 25.15 130.07C22.41 130.07 22.41 134.32 25.15 134.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M105.65 102.918C108.39 102.918 108.39 98.668 105.65 98.668C102.91 98.668 102.91 102.918 105.65 102.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.17 97.5781C61.91 97.5781 61.91 93.3281 59.17 93.3281C56.43 93.3281 56.43 97.5781 59.17 97.5781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M101.03 26.7305C103.77 26.7305 103.77 22.4805 101.03 22.4805C98.29 22.4805 98.29 26.7305 101.03 26.7305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.65 47C31.39 47 31.39 42.75 28.65 42.75C25.91 42.75 25.91 47 28.65 47Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M109.93 11.3817C108.41 12.9017 107.41 14.7617 106.96 16.7217L92.25 2.01172L77.29 16.9717C79.47 17.3617 81.56 18.3917 83.24 20.0717C87.61 24.4417 87.61 31.5117 83.24 35.8817C78.87 40.2517 71.8 40.2517 67.43 35.8817C65.75 34.2017 64.71 32.1117 64.33 29.9317L49.37 44.8917L64.08 59.6017C62.12 60.0617 60.27 61.0517 58.74 62.5717C54.37 66.9417 54.37 74.0117 58.74 78.3817C63.11 82.7517 70.18 82.7517 74.55 78.3817C76.07 76.8617 77.07 75.0017 77.52 73.0417L92.23 87.7517L135.1 44.8817L120.39 30.1717C122.35 29.7117 124.2 28.7217 125.73 27.2017C130.1 22.8317 130.1 15.7617 125.73 11.3917C121.36 7.02172 114.29 7.02172 109.92 11.3917L109.93 11.3817Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.88 49.3711L2 92.2411L44.87 135.111L59.82 120.161C60.21 122.341 61.24 124.421 62.92 126.101C67.29 130.471 74.36 130.471 78.73 126.101C83.1 121.731 83.1 114.661 78.73 110.291C77.05 108.611 74.96 107.581 72.79 107.191L87.74 92.2411",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_31248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.12,
    height: 137.12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact04);
export default __webpack_public_path__ + "static/media/icon_contact_04.6a59d7d535edb2b2389293881ba0aa43.svg";
export { ForwardRef as ReactComponent };